<app-topbar />
<div class="flex flex-col w-full gap-6 flex-1 px-4"> 
    <router-outlet />
</div>